module.exports = __webpack_public_path__ + "static/media/add-slack-url.f2b7437a.png";